import Model, { fields } from '@thinknimble/tn-models'

import BaseContentfulModel from '../BaseContentfulModel'
import FundAPI, { FundMetricAPI } from './api'

export default class Fund extends BaseContentfulModel {
  static api = FundAPI.create(Fund)

  static id = new fields.CharField()
  static fundTitle = new fields.CharField()
  static fundSummary = new fields.CharField()
  static lastUpdated = new fields.CharField()
  static leftUsageLabel = new fields.CharField()
  static rightUsageLabel = new fields.CharField()
  static leftUsageValue = new fields.CharField()
  static rightUsageValue = new fields.CharField()
  static percentageUsed = new fields.IntegerField({ defaultVal: 100 })
  static fundAccessGroups = new fields.ArrayField({ type: new fields.CharField() })
}

export class FundMetric extends BaseContentfulModel {
  static api = FundMetricAPI.create(FundMetric)
  static id = new fields.CharField()
  static value = new fields.CharField()
  static label = new fields.CharField()
  static order = new fields.IntegerField()
}
